<template>
  <el-dialog
    title="用户详情"
    :visible="visible"
    width="600px"
    @close="handleClose"
  >
    <div v-if="userData" class="user-detail">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="用户ID">
          {{ userData.userId }}
        </el-descriptions-item>

        <el-descriptions-item label="昵称">
          <div class="user-info">
            <el-avatar
              :size="30"
              :src="userData.avatar"
              style="margin-right: 8px"
            >
              {{ userData.nickName ? userData.nickName.charAt(0) : "U" }}
            </el-avatar>
            {{ userData.nickName }}
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="手机号">
          {{ userData.phone || "-" }}
        </el-descriptions-item>

        <el-descriptions-item label="邮箱">
          {{ userData.email || "-" }}
        </el-descriptions-item>

        <el-descriptions-item label="性别">
          {{ userData.gender | genderText }}
        </el-descriptions-item>

        <el-descriptions-item label="状态">
          <el-tag :type="userData.status === 0 ? 'success' : 'danger'">
            {{ userData.status | statusText }}
          </el-tag>
        </el-descriptions-item>

        <el-descriptions-item label="好友数量">
          {{ userData.friendCount || 0 }}
        </el-descriptions-item>

        <el-descriptions-item label="群组数量">
          {{ userData.groupCount || 0 }}
        </el-descriptions-item>

        <el-descriptions-item label="最后登录时间">
          {{ userData.lastLoginTime | formatDate }}
        </el-descriptions-item>

        <el-descriptions-item label="最后登录IP">
          {{ userData.lastLoginIp || "-" }}
        </el-descriptions-item>

        <el-descriptions-item label="注册时间">
          {{ userData.createdTime | formatDate }}
        </el-descriptions-item>

        <el-descriptions-item label="更新时间">
          {{ userData.updatedTime | formatDate }}
        </el-descriptions-item>

        <el-descriptions-item v-if="userData.remark" label="备注" :span="2">
          {{ userData.remark }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 最近活动 -->
      <div class="recent-activities" style="margin-top: 20px">
        <h4>最近活动记录</h4>
        <el-table :data="recentActivities" size="small">
          <el-table-column prop="type" label="活动类型" width="120" />
          <el-table-column prop="description" label="活动描述" />
          <el-table-column prop="createdTime" label="时间" width="150">
            <template slot-scope="scope">
              {{ scope.row.createdTime | formatDate }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="success" @click="handleManageGroups">群组管理</el-button>
      <el-button @click="handleClose">关闭</el-button>
    </div>

    <!-- 群组管理对话框 -->
    <user-group-manager
      :visible.sync="groupManagerVisible"
      :user-data="userData"
    />
  </el-dialog>
</template>

<script>
import { getUserActivities } from "@/api/user";
import UserGroupManager from "./UserGroupManager";

export default {
  name: "UserDetail",
  components: {
    UserGroupManager,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      recentActivities: [],
      groupManagerVisible: false,
    };
  },
  watch: {
    visible(val) {
      if (val && this.userData) {
        this.loadRecentActivities();
      }
    },
  },
  methods: {
    async loadRecentActivities() {
      try {
        const response = await getUserActivities(this.userData.id, {
          size: 10,
        });
        this.recentActivities = response.data || [];
      } catch (error) {
        console.error("加载活动记录失败:", error);
        // 模拟数据
        this.recentActivities = [
          {
            type: "登录",
            description: "用户登录系统",
            createdTime: new Date().toISOString(),
          },
          {
            type: "发送消息",
            description: "在群组中发送消息",
            createdTime: new Date(Date.now() - 3600000).toISOString(),
          },
        ];
      }
    },

    handleClose() {
      this.$emit("update:visible", false);
    },

    handleManageGroups() {
      this.groupManagerVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-detail {
  .user-info {
    display: flex;
    align-items: center;
  }

  .recent-activities {
    h4 {
      margin-bottom: 10px;
      color: #303133;
    }
  }
}
</style>
